@if (!billAddress) {
    <div class="card text-center {{ shippingAddress && shippingAddress.isPrincipal ? 'active' : '' }}">
        @if (getLabel()) {
            <div [class]="shippingAddress && shippingAddress.isPrincipal ? 'card-header selected-card-header' : 'card-header not-selected-card-header'">{{ getLabel() }}</div>
        }
        @if (!billAddress) {
            <div class="card-body">
                @if (shippingAddress) {
                    <div>
                        <div>{{ shippingAddress.company ? shippingAddress.company : '&nbsp;' }}</div>
                        <div class="bold-label-text pt-2">{{ shippingAddress.civility }} {{ shippingAddress.lastName }} {{ shippingAddress.firstName }}</div>
                        <div>{{ shippingAddress.street }}</div>
                        <div>{{ shippingAddress.addressComplement }}</div>
                        <div class="bold-label-text">{{ shippingAddress.zipCode }} {{ shippingAddress.city }}</div>
                        @if (shippingAddress.placeName) {
                            <div>{{ shippingAddress.placeName ? shippingAddress.placeName : '&nbsp;' }}</div>
                        }
                    </div>
                }
            </div>
        }
        <div class="icon-tools">
            @if (shippingAddress && displayButton) {
                <button
                        type="button"
                        class="cta_btn level_2 address"
                        (click)="displayPasswordModal('adresse-livraison')"
                >Modifier<span></span></button>
            }
            @if (shippingAddress && displayButton && !shippingAddress.isPrincipal) {
                <button
                        id="delete_1"
                        type="button"
                        class="cta_btn level_2"
                        (click)="displayPasswordModal('delete-shipping-address')"
                >Supprimer
                </button>
            }
        </div>
        @if (displayButton && !shippingAddress.isPrincipal) {
            <div class="radio-button-div cta-grid">
                @if (shippingAddress && !shippingAddress.isPrincipal) {
                    <input
                            id="radio_{{ index }}"
                            class="radio-medium"
                            type="radio"
                            name="address"
                            [checked]="shippingAddress.isPrincipal"
                            (click)="displayPasswordModal('selected-shipping-address')"
                    />
                }
            </div>
        }
    </div>
}

@if (!shippingAddress && displayButton) {
    <button
            id="add-address"
            type="button"
            class="cta_btn level_2 add-button"
            (click)="displayPasswordModal('add-shipping-address')"
    >Ajouter une adresse<span></span></button>
}
